var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"readNextContainer bg-light w-100"},[_c('h3',{staticClass:"text-center"},[_vm._v("What to read next")]),_vm._v(" "),_c('div',{staticClass:"readNextList mx-auto"},_vm._l((_vm.posts.slice(0, 3)),function(post){return _c('PostGridItem',{key:post.id,attrs:{"post":post}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }